import React from "react";

const PropertyContext = React.createContext();

export default PropertyContext;
